import { Trans } from '@lingui/macro'
import { Save } from '@mui/icons-material'
import {
  Button,
  Dialog,
  DialogContent,
  Grid
} from '@mui/material'
import { Component, useEffect } from 'react'
import { Prompt, useHistory } from 'react-router'
import { ButtonIcon } from './ButtonIcon'
import { DialogTitleWithIconClose } from './DialogTitleWithIconClose'

export default class RedirectWarning extends Component {
  state = { openDialog: false }

  constructor (props) {
    super(props)
    this.handleRedirect = this.handleRedirect.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
  }

  handleRedirect () {
    this.setState({ canRedirect: true, openDialog: false })
  }

  handleCancel () {
    this.setState({ openDialog: false })
    if (this.props.handleCancel) {
      this.props.handleCancel()
    }
  }

  render () {
    const { openDialog, canRedirect, location } = this.state
    const { open, handleSave, handleCancel } = this.props

    return (
      <>
        <RedirectDialog
          handleSave={() => {
            handleSave()
            this.setState({ openDialog: false })
          }}
          open={openDialog}
          canRedirect={canRedirect}
          cancel={this.handleCancel}
          redirect={this.handleRedirect}
          location={location}
        />
        <Prompt
          when={open}
          message={(location, action) => {
            if (canRedirect) {
              return true
            }
            this.setState({ openDialog: true, location })
            return false
          }}
        />
      </>
    )
  }
}

const RedirectDialog = ({
  open,
  redirect,
  location,
  canRedirect,
  cancel,
  handleSave
}) => {
  const history = useHistory()

  useEffect(() => {
    if (canRedirect) {
      history.push(location)
    }
  }, [canRedirect])

  return (
    <Dialog open={open} maxWidth='xs' fullWidth>
      <DialogTitleWithIconClose
        handleClose={e => {
          cancel()
        }}
        label={<Trans>There are unsaved changes present in this form!</Trans>}
      />
      <DialogContent>
        <Trans>Would you like to save your changes before leaving?</Trans>

        <Grid container direction='column' gap='8px' sx={{ marginTop: '16px' }}>
          {handleSave && (
            <Button
              fullWidth
              variant='contained'
              color='primary'
              onClick={() => {
                handleSave()
              }}
            >
              <Trans>Save</Trans>
              <ButtonIcon IconClass={Save} />
            </Button>
          )}
          <Button
            fullWidth
            variant='outlined'
            color='primary'
            onClick={() => {
              redirect()
            }}
          >
            <Trans>Leave without saving</Trans>
          </Button>

          <Button
            fullWidth
            variant='outlined'
            color='primary'
            onClick={() => {
              cancel()
            }}
          >
            <Trans>Cancel</Trans>
          </Button>
        </Grid>
      </DialogContent>

    </Dialog>
  )
}
